<app-card class="header">
  <div>
    <app-ribbon type="prototype" />
    <h1 i18n class="title">Public landscape objects</h1>
    <p i18n>Discover objects like windmills, lakes, and more in your fields in just a few steps</p>
    <p i18n>
      With this tool, you can easily identify objects within a field boundary. Simply upload a file with your field
      boundary, and our tool will return public landscape objects in your field, such as windmills, lakes, and roads,
      using data from OpenStreetMap. You can review the found objects and download an updated file with your field and
      the found objects. This file can be uploaded to your farm management system or directly to your tractor's terminal
      for use in the planning and execution of your fieldwork.
    </p>
  </div>
  <div>
    <div i18n>TRY IT OUT</div>
    <ul>
      <li>
        <app-bullet size="small">1</app-bullet>
        <span i18n>Upload a file containing your field boundary - or use our example field</span>
      </li>
      <li><app-bullet size="small">2</app-bullet> <span i18n>Check the objects identified at the field</span></li>
      <li>
        <app-bullet size="small">3</app-bullet>
        <span i18n>Download the file including the objects, and upload it to your terminal</span>
      </li>
    </ul>
    <p class="info-feedback">
      <span i18n>... and let us know what you think -</span>
      <app-link i18n target="_self" [href]="goToFeedback()">send your feedback</app-link>
    </p>
  </div>
</app-card>
<app-card class="upload">
  <app-card-title
    i18n-title
    i18n-subtitle
    bullet="1"
    title="select field:"
    subtitle="Upload an ISOXML file (v3 or v4) with a field boundary.
              You can use a ZIP file with the structure TASKDATA/TASKDATA.XML."
  />
  <form class="file-upload" [formGroup]="fileForm" (ngSubmit)="uploadFile()">
    <app-file-upload i18n formControlName="file" accept=".xml,.zip">Drag and drop or browse your file</app-file-upload>
    <app-button i18n type="submit" variant="primary" [disabled]="!fileForm.valid">Find Objects</app-button>
  </form>
  <div i18n class="divider">- or -</div>
  <form [formGroup]="exampleForm" (ngSubmit)="exampleFile()">
    <app-button i18n type="submit" variant="primary">Try our example field</app-button>
  </form>
</app-card>
<app-card class="map">
  <app-card-title
    i18n-title
    i18n-subtitle
    bullet="2"
    title="Explore objects in the field"
    subtitle="At the map you will see the objects available in the online registry within the field boundary.
              You can Show/Hide different object types in the layer drop down"
  />
  @let features = mapFeatures();
  @if (!features || features === "loading" || features === "no-data") {
    <div [ngStyle]="{ height: mapHeight }" class="placeholder">
      @if (!features) {
        <app-icon icon="map" />
        <div i18n>Please select a file above</div>
      } @else if (features === "loading") {
        <app-icon icon="travel_explore" />
        <div i18n>Loading</div>
      } @else if (features === "no-data") {
        <app-icon icon="location_off" />
        <div i18n>No objects found</div>
      }
    </div>
  } @else {
    <app-map [height]="mapHeight" [features]="features" />
  }
</app-card>
<app-card class="download">
  <app-card-title
    i18n-title
    i18n-subtitle
    bullet="3"
    title="Download"
    subtitle="Download an ISOXML file with the field boundary and the objects found in the public registry. You can use this file in your farm management system or tractor terminal."
  />
  <app-button i18n variant="primary" [disabled]="!mapFeatures()" (buttonClick)="download()">Download</app-button>
</app-card>
<app-card id="feedback">
  <app-feedback-card feature="public-landscape-objects" />
</app-card>
